import { withAuthenGuard } from '@libs/hoc/withAuthenGuard'
import { AppLayout } from './AppLayout'
import { withAppLayout } from './withAppLayout'

const ConnectedAppLayout = withAuthenGuard(withAppLayout(AppLayout))

export { ConnectedAppLayout as AppLayout }
